import { render } from "./artists.vue?vue&type=template&id=668593e8"
import script from "./artists.vue?vue&type=script&lang=js"
export * from "./artists.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/artsys-st/artch-artsys/Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__